import { z, ZodType } from 'zod';
import { Account } from './account';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';
import { Wallet, walletSchema } from './wallet';

export type AccountWithWallets = {
	parents: string;
	parent: EntityWithName | null;
	wallets: Wallet[];
} & Account;

export const accountWithWalletsSchema: ZodType<AccountWithWallets> = z.object({
	id: z.number(),
	name: z.string(),
	note: z.string().nullable(),
	isLocked: z.boolean(),
	createdAt: z.string(),
	parents: z.string(),
	wallets: z.array(walletSchema),
	parent: entityWithNameSchema.nullable(),
});
